/**
 * @copyright NIIT Technologies Ltd. 2017-18.
 */

// Angular
import { NgModule } from '@angular/core';

// NGC Overlay Controls
import { NgcTooltipModule } from '../controls/tooltip/ngc-tooltip.component';

/**
 * NGC Overlay Module
 */

export class NgcOverlayModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    exports: [
        NgcTooltipModule
    ]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
